/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {StorageUsageResponse} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Returns the current user's storage usage and quota
 */
export type getMyUsageResponse200 = {
  data: StorageUsageResponse
  status: 200
}

export type getMyUsageResponseSuccess = getMyUsageResponse200 & {
  headers: Headers
}
export type getMyUsageResponse = getMyUsageResponseSuccess

export const getGetMyUsageUrl = () => {
  return `/storage/me`
}

export const getMyUsage = async (options?: RequestInit): Promise<getMyUsageResponse> => {
  return customFetch<getMyUsageResponse>(getGetMyUsageUrl(), {
    ...options,
    method: 'GET',
  })
}
